var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{'sidebar-lang': this.$parent.name === 'Sidebar', 'language-selector' : true}},[_c('Select',{ref:"select",attrs:{"name":"singleSelect","label":_vm.label,"value":_vm.selectedValue,"allOptions":_vm.allLanguages},on:{"change":function($event){return _vm.changeLanguage($event)}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }